import { z } from 'zod';
import { eventSchema } from './envelope';

export const ACCESS_ROLE_CREATED_V1 = 'access.role.created.v1' as const;
export const ACCESS_ROLE_CHANGED_V1 = 'access.role.changed.v1' as const;
export const ACCESS_ROLE_DELETED_V1 = 'access.role.deleted.v1' as const;
export const ACCESS_ROLE_ASSIGNED_V1 = 'access.role.assigned.v1' as const;
export const ACCESS_ROLE_UNASSIGNED_V1 = 'access.role.unassigned.v1' as const;

export const roleCreatedV1Schema = eventSchema({
  roleId: z.guid(),
  key: z.string().nullable(),
  policyKeys: z.array(z.string()),
});

/**
 * De rechten van een rol zijn gewijzigd. Iedereen met deze rol mag vanaf nu iets meer of
 * iets minder; `personIds` staat er bewust in, zodat een luisteraar (en de rechtencache)
 * niet eerst hoeft op te zoeken wie het betreft.
 */
export const roleChangedV1Schema = eventSchema({
  roleId: z.guid(),
  changed: z.array(z.string()),
  personIds: z.array(z.guid()),
});

export const roleDeletedV1Schema = eventSchema({
  roleId: z.guid(),
  personIds: z.array(z.guid()),
});

export const roleAssignedV1Schema = eventSchema({
  personId: z.guid(),
  roleIds: z.array(z.guid()),
});

export const roleUnassignedV1Schema = eventSchema({
  personId: z.guid(),
  roleIds: z.array(z.guid()),
});

export type RoleCreatedV1 = z.infer<typeof roleCreatedV1Schema>;
export type RoleChangedV1 = z.infer<typeof roleChangedV1Schema>;
export type RoleDeletedV1 = z.infer<typeof roleDeletedV1Schema>;
export type RoleAssignedV1 = z.infer<typeof roleAssignedV1Schema>;
export type RoleUnassignedV1 = z.infer<typeof roleUnassignedV1Schema>;

export const accessEventCatalog = {
  [ACCESS_ROLE_CREATED_V1]: roleCreatedV1Schema,
  [ACCESS_ROLE_CHANGED_V1]: roleChangedV1Schema,
  [ACCESS_ROLE_DELETED_V1]: roleDeletedV1Schema,
  [ACCESS_ROLE_ASSIGNED_V1]: roleAssignedV1Schema,
  [ACCESS_ROLE_UNASSIGNED_V1]: roleUnassignedV1Schema,
} as const;
